import AvailabilityRestriction from "@/models/Workers/AvailabilityRestriction";

export default (availabilityRestriction: AvailabilityRestriction) => {
    let returnVal = "None"
    switch (availabilityRestriction) {
        case AvailabilityRestriction.Uk48HourDirective:
            returnVal = "48 Hour Working Time Directive";
            break;
        case AvailabilityRestriction.Uk20HourStudentVisa:
            returnVal = "20 Hour Student Visa";
            break;
        
    }
    return returnVal;
} 
